<template>
  <div>
    <template v-if="flag">
      <el-button :size="btnSize" class="mob-show-create" :disabled="disabled" @click="dialogObject=true">Прикрепить файл</el-button>
      <div :class="['desktop-show-create', {disabled: disabled}]" @click="dialogObject=true">
        <strong style="font-size: 17px; color: #000">Прикрепить файл</strong>
        <div class="plus-btn">+</div>
      </div>
    </template>
    <template v-else>
      <el-button :size="btnSize" :disabled="disabled" @click="dialogObject=true">Прикрепить файл</el-button>
    </template>

    <el-dialog append-to-body
               title="Прикрепить файл" :disabled="disabled"
               :visible.sync="dialogObject">
      <el-upload
        disabled:="disabled"
        :on-change="onFilesSelected"
        v-if="uploadValue === null"
        list-type="picture"
        :http-request="onUpload"
        action="/"
        class="upload-demo"
        accept="image/*"
        :show-file-list="false"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Перетащите файл сюда или <em>нажмите, чтобы загрузить</em></div>
      </el-upload>
      <el-progress v-else :percentage="uploadValue"></el-progress>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'UploadFile',
  props: {
    btnSize: {
      type: String,
      default: null,
    },
    fileListProps: Array,
    disabled: Boolean,
    flag: Boolean
  },
  data() {
    return {
      search: '',
      fileList: [],
      dialogObject: false,
      unit: '',
      totalFiles: 0,
      uploadedFiles: 0,
      uploadValue: null,
      jobs: [],
      step: 0,
      form: {
        value: '',
        unit: '',
        job: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  watch: {
    fileListProps() {
      this.fileList = this.fileListProps;
    },
  },
  methods: {
    onFilesSelected(file, fileList) {
      this.totalFiles = fileList.length;
      this.uploadedFiles = 0;
    },

    // Этот вызывается на каждый файл отдельно
    onUpload(e) {
      const file = e.file;
      const ext = file.name.split('.').pop();
      const ref = firebase.storage().ref(`reports/${uuidv4()}.${ext}`);
      const task = ref.put(file);

      task.on(
        'state_changed',
        snapshot => {
          this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.error('Upload error:', error);
        },
        () => {
          ref.getDownloadURL().then(url => {
            this.$emit('add-file', url);
            this.uploadedFiles++;

            if (this.uploadedFiles === this.totalFiles) {
              // Все файлы загружены!
              this.uploadValue = 100;
              this.dialogObject = false;
              this.uploadValue = null;
              this.totalFiles = 0;
              this.uploadedFiles = 0;
            }
          });
        }
      );
    },
    save() {
      this.$emit('add-job', {
        ...this.form,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
      this.form.job = '';

      this.step = 0;
    },
  },
};
</script>

<style lang="scss">
.plus-btn {
  width: 48px;
  height: 32px;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff8c00;
}

.desktop-show-create {
  display: flex;
  align-items: center;

  strong {
    margin-right: 10px;
  }
}

.upload-demo {
  margin: 0 auto;
  z-index: 999999;
  width: calc(100% - 20px);

  .el-upload-dragger {
    max-width: 100% !important;
  }

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
    max-width: 360px;
  }
}

.disabled {
    opacity: 0.6;
    pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/UploadFile.vue